import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePriceGroup } from 'core/contexts/priceGroup';
import { EntityServiceV2 } from 'core/api/services/lookUp';
import { Field, Form } from 'react-final-form';
import { LookUpPriceGroupTab } from '@utriper/core-ui';
import { Box, FormHelperText, Grid2, InputLabel } from '@mui/material';
import ActionButtons from '../ActionButtons';
import Title from 'modules/Pricing/components/Title';

const ChangeListForm = ({ priceGroupId, handleClose = () => {} }) => {
    const { t } = useTranslation();
    const translate = (key) => t(`price_group_id.move_price_group_form.${key}`);
    const { submittingPriceGroup, movePriceGroup } = usePriceGroup();

    const [submitted, setSubmitted] = useState(false);
    const validateForm = (values) => {
        const errors = {};

        if (!values?.priceGroupTabId) {
            errors.priceGroupTabId = 'Requerido!';
        }

        return errors;
    };

    const handleSubmit = async (values) => {
        await movePriceGroup(priceGroupId, values?.priceGroupTabId);
        handleClose();
    };

    return (
        <Form
            key={`change-list-form-${priceGroupId}`}
            onSubmit={handleSubmit}
            validate={validateForm}
            render={({ values, errors, handleSubmit, form }) => (
                <Box component="form" py={2} key={`change-list-form-${priceGroupId}`} noValidate>
                    <Title title={translate('title')} description={translate('description')} />

                    {/* Form */}
                    <Grid2 container direction="column" justifyContent="flex-start" alignItems="flex-start" gap="8px" mt="24px">
                        <Grid2
                            container
                            width="100%"
                            direction="column"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                            gap="4px"
                            sx={{
                                '& .MuiAutocomplete-root': { width: '100%' },
                                '& .MuiOutlinedInput-notchedOutline': submitted && errors?.priceGroupTabId ? { borderColor: 'red' } : '',
                            }}
                        >
                            <InputLabel
                                sx={{
                                    fontSize: '18px',
                                    fontWeight: 400,
                                    color: '#131313',
                                }}
                            >
                                {translate('price_group_tab_label')}
                            </InputLabel>
                            <Field
                                id="priceGroupTab"
                                name="priceGroupTab"
                                render={({ input, meta }) => (
                                    <LookUpPriceGroupTab
                                        {...input}
                                        {...meta}
                                        label={translate('price_group_tab_placeholder')}
                                        entityService={EntityServiceV2}
                                        value={values?.priceGroupTabId}
                                        initialValue={values?.priceGroupTabId}
                                        onChange={(newValue) => {
                                            form.change('priceGroupTabId', newValue);
                                        }}
                                    />
                                )}
                            />
                            {submitted && errors?.priceGroupTabId && <FormHelperText error>{errors.priceGroupTabId}</FormHelperText>}
                        </Grid2>
                    </Grid2>

                    <ActionButtons
                        handleSubmit={(e) => {
                            setSubmitted(true);
                            return handleSubmit(e);
                        }}
                        handleClose={(e) => {
                            handleClose();
                            setSubmitted(false);
                            return form.reset(e);
                        }}
                        submitting={submittingPriceGroup}
                        labelNext={translate('send_button')}
                    />
                </Box>
            )}
        />
    );
};

export default ChangeListForm;
